import React from "react";
import { Link, useNavigate, useParams } from "react-router-dom";
import {
  Box,
  Button,
  Center,
  CircularProgress,
  Container,
  Flex,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalOverlay,
  Spinner,
  Table,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
  useToast,
} from "@chakra-ui/react";
import { useEffect, useRef, useState } from "react";
import { FuncButton } from "../../customComponents/components/FuncButton";
import { PageHead } from "../../home/components/PageHead";
import { TableHead } from "../../home/components/TableHead";
import { head } from "../helpers";
import { useArticleList } from "../hooks";
import { request } from "../../httpClient";

export const ArticleListScreen = () => {
  const { articleList, articleListLoading, getArticleList } = useArticleList();
  const navigate = useNavigate();
  console.log("articleList", articleList);
  return (
    <div>
      <PageHead
        breadCrumbs={<Heading>Статьи</Heading>}
        onClick={() => {
          navigate(`/article_set`);
          // navigate(`/travel_set?user_id=${id}`);
          // setActiveMarkId(null);
          // setModalIsOpen(true);
        }}
        linkLabel="Добавить статью"
      >
        {articleListLoading ? (
          <Container height="calc(100vh - 240px)">
            <Spinner position={"absolute"} top="50%" right="50%" size="xl" />
          </Container>
        ) : (
          <TableHead column={head}>
            {articleList?.map(({ id, title }) => (
              <Tr key={id}>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {id}
                  </Text>
                </Td>
                <Td>
                  <Text fontSize="sm" color="#121419">
                    {title}
                  </Text>
                </Td>
                <Td isNumeric>
                  <FuncButton
                    onClick={() => {
                      navigate(`/article_set/${id}`);
                      // setActiveMarkId(id);
                      // setModalIsOpen(true);
                      // setTimeout(() => {
                      //   labelRef.current.value = label;
                      // }, 500);
                    }}
                  >
                    РЕДАКТИРОВАТЬ
                  </FuncButton>
                </Td>
                <Td isNumeric>
                  <Button
                    marginLeft={"20px"}
                    colorScheme="red"
                    onClick={() => {
                      if (window.confirm("Пожалуйста, подтвердите удаление")) {
                        request({
                          path: "article/delete",
                          method: "POST",
                          body: JSON.stringify({ id }),
                        }).then(() => getArticleList());
                        // vehicleMarkDeleteReq({ id }).then(() => {
                        //   getVehicleMarkList();
                        // });
                      }
                    }}
                  >
                    Удалить
                  </Button>
                </Td>
              </Tr>
            ))}
          </TableHead>
        )}
      </PageHead>
    </div>
  );
};
